// src/App.jsx
import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import ScrollToTop from "./components/ScrollToTop";
import Navbar from "./components/Navbar";

import Home from "./pages/Home";
import Contact from "./pages/Contact";
import About from "./pages/About";
import Dress from "./pages/Dress";
import CodeConduct from "./pages/CodeConduct";
import Guidelines from "./pages/Guideline";
import AcademicCalendar from "./pages/Calendar";
import NoticePage from "./pages/NoticePage";
import Admission from "./pages/Admission";
import AdmissionFormPage from "./pages/AdmissionFormPage";
import ApplyOnlinePage from "./pages/ApplyOnlinePage";
import ActivitiesCalendar from "./pages/ActivitiesCalendarPage";
import StaffInfoPage from "./pages/StaffInfoPage";
import FeesPaymentPage from "./pages/FeesPaymentPage";
import MessagesPage from "./pages/MessagesPage";
import PhotosPage from "./pages/PhotosPage";
import VideosPage from "./pages/VideosPage";


function App() {
  const location = useLocation();

  return (
    <>
      <ScrollToTop />
      <Navbar />

      <Routes>
        {/* General Pages */}
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />

        {/* Administration Section */}
        <Route path="/administration/messages" element={<MessagesPage />} />
        <Route
          path="/administration/staff-information"
          element={<StaffInfoPage />}
        />

        {/* Academic Section */}
        <Route path="/academic/dress-code" element={<Dress />} />
        <Route path="/academic/code-of-conduct" element={<CodeConduct />} />
        <Route path="/academic/guideline-for-parents" element={<Guidelines />} />
        <Route path="/academic/academic-calendar" element={<AcademicCalendar />} />
        <Route path="/academic/activities-calendar" element={<ActivitiesCalendar />} />

        {/* Gallery Section */}
        <Route path="/gallery/photos" element={<PhotosPage />} />
        <Route path="/gallery/Videos" element={<VideosPage />} />

        {/* Notice Section */}
        <Route path="/notice" element={<NoticePage />} />

        {/* Admission Section */}
        <Route path="/admission/admission-info" element={<Admission />} />
        <Route path="/admission/admission-form" element={<AdmissionFormPage />} />
        <Route path="/admission/fees-payment" element={<FeesPaymentPage />} />
        <Route path="/admission/apply-online-page" element={<ApplyOnlinePage />} />
      </Routes>
    </>
  );
}

export default App;
